"use client";
import Gatekeeper from ".";

import { useEffect } from "react";

export const GatekeeperClient = () => {
  useEffect(() => {
    void Gatekeeper.init();
  }, []);
  return null;
};
